// ** Third Party Components
import styled, { css } from "styled-components";
import { Icon, createIconComponent } from "components/icons";

// #####################################################

export const StyledSvgIconContainer = styled.div`
	display: flex;
	position: relative;
	top: 1px;
	${({ customMargin }) =>
		customMargin &&
		css`
			margin: ${customMargin};
		`}

	svg {
		display: inline-block;
		vertical-align: middle;
	}
`;

// #####################################################

export const TrashIconCustom = ({ customMargin, height }) => {
	return (
		<StyledSvgIconContainer customMargin={customMargin}>
			<Icon name="trash" variant="regular" height={height} />
		</StyledSvgIconContainer>
	);
};

const TrashIcon = createIconComponent("trash", "solid");

// #####################################################

export default TrashIcon;

// #####################################################
